import React from "react";
import { Link } from "gatsby";
import { WrapRootElement } from "../mdx";
import Header from "../Header";
import Footer from "../Footer";
import AddCartModal from "../AddCartModal";
import SEO from "../Seo";

import "./global.css";
import styles from "./styles.module.css";

const Layout = ({ children }) => {
  return (
    <>
      <WrapRootElement>
        <SEO />
        <div className={styles.content}>
          <Header />
          <main className={styles.main}>
            <div className={styles.information}>
              La boutique en ligne est temporairement FERMÉE jusqu'au 1er
              février 2022 sauf pour les{" "}
              <Link to={"/categories/bons-et-coffrets-cadeaux/"}>
                bons et coffrets cadeaux
              </Link>
              . N'hésitez pas à nous contacter par téléphone au &#160;
              <a href="tel:+33472640298">04.72.64.02.98</a> ou sur nos réseaux
              sociaux pour toute commande à venir retirer en boutique. Bel été à
              tous, l'équipe de Mercredi !
            </div>
            {children}
          </main>
          <Footer />
        </div>
        <AddCartModal />
      </WrapRootElement>
    </>
  );
};

export default Layout;
